class CustomComplementaryProducts extends HTMLElement {
  constructor() {
    super();
    this.productId = Number(this.getAttribute('data-product-id')) || null;
    this.limit = Number(this.getAttribute('data-limit')) || 10;
    this.container = this.querySelector('.custom-slider-container-list');
    this.dotsContainer = this.querySelector('.custom-slider-dot-list');
    this.slider = this.querySelector('custom-slider');
    this.init();
  }

  init = async () => {
    const products = await this.getProducts();
    if (!products || !products.length || products === undefined) {
      this.classList.add('hide');
      return;
    }
    let j = 0;
    for (let i = 0; i < products.length; i += 2) {
      const wrapper = document.createElement('div');
      wrapper.classList.add(
        'custom-slide',
        'custom-product-complementary_control-slide',
      );
      wrapper.appendChild(products[i]);
      if (products[i + 1]) wrapper.appendChild(products[i + 1]);
      this.container.appendChild(wrapper);
      if (this.dotsContainer) {
        const dot = document.createElement('div');
        dot.classList.add(
          'custom-slider-dot',
          'custom-product-complementary_control-dot',
        );
        dot.setAttribute('data-index', j);
        this.dotsContainer.appendChild(dot);
      }
      j++;
    }
    this.slider.dispatchEvent(new CustomEvent('build:slider'));
    if (window.AOS) {
      AOS.init();
    }
  };

  getProducts = async () => {
    const complementaryProducts = await this.fetchProductRecommendations();

    if (!complementaryProducts) {
      return;
    }

    return await Promise.all(
      complementaryProducts.map(async (product) => {
        let url = `/products/${product.handle}?view=complementary`;
        const rawProductCard = await fetch(url).then((res) => res.text());
        return this.parseHTML(rawProductCard);
      }),
    );
  };

  fetchProductRecommendations = async () => {
    const response = await fetch(
      `/recommendations/products.json?product_id=${this.productId}&limit=${this.limit}&intent=complementary`,
    ).then((res) => res.json());

    if (response.message) {
      return null;
    }

    return response.products.length ? response.products : null;
  };

  parseHTML = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    return doc.body.firstChild;
  };
}

if (!customElements.get('custom-complementary-products')) {
  customElements.define(
    'custom-complementary-products',
    CustomComplementaryProducts,
  );
}
